import { createContext } from "react"

export interface PendoContextValue {
  track: (eventName: string, properties?: Record<string, unknown>) => void;
  trackAgent: (
    eventType: "prompt" | "agent_response" | "user_reaction",
    metadata: {
      agentId: string;
      conversationId: string;
      messageId: string;
      content: string;
    }
  ) => void;
}

export const PendoContext = createContext<PendoContextValue | null>(null)
